module.exports = __webpack_public_path__ + "img/raid44l.8a33b083.jpg";